import DashboardGrid from '@/features/dashboard/DashboardGrid';
import DashboardHeader from '@/features/dashboard/DashboardHeader';

export default function DashboardPage() {
  return (
    <>
      <DashboardHeader />
      <DashboardGrid />
    </>
  );
}
